import * as React from 'react';
import { TZUtils } from 'lib/tzutils';
import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';
import { DateRange } from 'portcall/daterangeselector/model';
import { parseDateRange, outboundDateRangeParams } from 'portcall/daterangeselector/routeParams';
import { PortCallUserRoleDisplayName } from 'server/enums/PortCallUserRole';
import { parsePortCallUserRole, parseDate } from 'common/services/routeParams';
import { ReservationsDashboard, ReservationsDashboardParams, DefaultRole } from './model';
import { ReservationsDashboardView } from './view';
import { AppWrapper } from '../appwrapper/model';
import { AppWrapperView } from '../appwrapper/view';

export const ReservationsDashboardRoute = (
    model: (params : ReservationsDashboardParams) => ReservationsDashboard,
    appWrapper : AppWrapper,
    tzutils : TZUtils,
    request : Location
) : IRoute => {
    const m = model(inboundParams(request, tzutils));
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <ReservationsDashboardView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
};

function inboundParams(request : Location, tzutils : TZUtils) : ReservationsDashboardParams {
    const orgId = request.params['orgId'],
        range = request.params['range'],
        role = request.params['role'],
        from = request.params['from'],
        to = request.params['to'],
        filter = request.params['filter'];

    return {
        orgId: orgId !== undefined ? +orgId : undefined,
        range: range !== undefined ? parseDateRange(range) : DateRange.ThisMonth,
        role: role !== undefined ? parsePortCallUserRole(role) : undefined,
        from: from !== undefined ? parseDate(from, tzutils) : undefined,
        to: to !== undefined ? parseDate(to, tzutils) : undefined,
        filter
    };
}

function outboundParams(request : Location, m : ReservationsDashboard) {
    const params = {} as LocationParams;
    params['orgId'] = m.OrgId + '';
    outboundDateRangeParams(m.DateRangeSelector, params, DateRange.ThisMonth, { range: 'range', from: 'from', to: 'to' });
    if (m.Filter()) params['filter'] = m.Filter();
    if (m.Role() !== DefaultRole) params['role'] = PortCallUserRoleDisplayName[m.Role()];
    return new Location(request.name, params);
}


// WEBPACK FOOTER //
// ./apps/portcall/reservationsdashboard/route.tsx